var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import mtzService from "@/core/services/mtzService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Nivel_HabilidadeActions } from "@/store/enums/mtzEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Nivel_HabilidadeModule = class Nivel_HabilidadeModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Nivel_HabilidadeActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            mtzService.getFile("Nivel_Habilidade/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Nivel_Habilidade.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Nivel_HabilidadeActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            mtzService.postFile("Nivel_Habilidade/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Nivel_HabilidadeActions.POST_NIVEL_HABILIDADE](data) {
        return new Promise(resolve => {
            mtzService.post("Nivel_Habilidade/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Nivel_HabilidadeActions.PUT_NIVEL_HABILIDADE](data) {
        return new Promise(resolve => {
            mtzService.put("Nivel_Habilidade/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Nivel_HabilidadeActions.DELETE_NIVEL_HABILIDADE](data) {
        return new Promise(resolve => {
            mtzService.delete("Nivel_Habilidade/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Nivel_HabilidadeActions.DELETE_RANGE_NIVEL_HABILIDADE](data) {
        return new Promise(resolve => {
            mtzService.delete("Nivel_Habilidade/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Nivel_HabilidadeActions.FILTER_NIVEL_HABILIDADE](data) {
        return new Promise(resolve => {
            mtzService.post("Nivel_Habilidade/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Nivel_HabilidadeActions.GET_NIVEL_HABILIDADE]() {
        return new Promise(resolve => {
            mtzService.get("Nivel_Habilidade/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Nivel_HabilidadeActions.GETWITHDISABLED_NIVEL_HABILIDADE]() {
        return new Promise(resolve => {
            mtzService.get("Nivel_Habilidade/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Nivel_HabilidadeActions.GET_BY_ID_NIVEL_HABILIDADE](data) {
        return new Promise(resolve => {
            mtzService.get("Nivel_Habilidade/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Nivel_HabilidadeModule.prototype, _k, null);
Nivel_HabilidadeModule = __decorate([
    Module
], Nivel_HabilidadeModule);
export default Nivel_HabilidadeModule;
//# sourceMappingURL=Nivel_HabilidadeModule.js.map